import { takeEvery, call, put, select } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator, gridSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	orderBlacklistApi,
	OrdersBlackListModel,
	orderBlacklistSelect,
	orderBlackListSlice,
	OrderBlackListNS,
} from 'Pages/orders'

function* getAll(action: OrderBlackListNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		const res = yield* call(orderBlacklistApi.getAll, params)
		const items = new ResponseCatalog<OrdersBlackListModel>(res)
		if (!clear && params.page !== 1) {
			const oldItems = yield* select(orderBlacklistSelect.getAll)
			items.entries = oldItems.concat(items.entries)
		}
		yield* put(orderBlackListSlice.actions.setAll(items))
		yield* put(orderBlackListSlice.actions.setParams(params))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* createOne(action: OrderBlackListNS.CreateOne) {
	try {
		yield* call(orderBlacklistApi.createOne, action.payload)
		yield* put(orderBlackListSlice.actions.getAll({ params: new RequestParams(), clear: true }))
		yield* call(notifyMessageCreator, 'orders.create_blocking_rule.success', {
			data: [action.payload.company_name],
		})
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateOne(action: OrderBlackListNS.UpdateOne) {
	try {
		const { id, data } = action.payload
		yield* call(orderBlacklistApi.updateOne, id, data)
		yield* put(orderBlackListSlice.actions.getAll({ params: new RequestParams(), clear: true }))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* deleteOne(action: OrderBlackListNS.DeleteOne) {
	try {
		yield* call(orderBlacklistApi.deleteOne, action.payload)
		yield* put(orderBlackListSlice.actions.getAll({ params: new RequestParams(), clear: true }))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* checkInn(action: OrderBlackListNS.CheckInn) {
	try {
		const { inn, callback } = action.payload
		const res = yield* call(orderBlacklistApi.checkInn, inn)
		callback?.(res)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const sagaBlackList = function* saga() {
	yield* takeEvery(orderBlackListSlice.actions.getAll.type, getAll)
	yield* takeEvery(orderBlackListSlice.actions.createOne.type, createOne)
	yield* takeEvery(orderBlackListSlice.actions.updateOne.type, updateOne)
	yield* takeEvery(orderBlackListSlice.actions.deleteOne.type, deleteOne)
	yield* takeEvery(orderBlackListSlice.actions.checkInn.type, checkInn)
}
